enum TextEnhancementType {
  POLISH = "POLISH",
  FORMALIZE = "FORMALIZE",
  ELABORATE = "ELABORATE",
  SHORTEN = "SHORTEN",
  FIRST_PERSON = "FIRST_PERSON"
}

export default TextEnhancementType;
